export default "__VITE_ASSET__CbmZY5Oo__"